import { SxProps, Theme } from '@mui/material';

export const footerTypographyUppercaseBaseSX: SxProps = {
	fontSize: '0.875rem',
	fontWeight: 'bold',
	textTransform: 'uppercase',
};

export const footerTypographyUnfocusedSX: SxProps = {
	color: '#929292',
	marginBottom: { xs: '0px', md: '11px' },
	fontSize: 'var(--font-size-small)',
	textDecoration: 'underline',
};

export const footerContainerSX = (csrSession: boolean): SxProps<Theme> => ({
	borderRadius: '0',
	alignSelf: 'stretch',
	justifySelf: 'flex-end',
	backgroundColor: 'background.paper',
	color: 'background.disabled',
	marginBottom: '0',
	img: {
		height: (theme) => theme.spacing(3),
	},
	...(!csrSession && { mt: 'auto' }),
});

export const footerTopSX: SxProps<Theme> = {
	pt: { md: '38px', xs: 3 },
	pb: { md: 5, xs: 3.4 },
	width: '100%',
	ml: '0px',
};
